
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#023E92"}}),_c('path',{attrs:{"d":"M26 21v-7.875c0-.298-.115-.585-.32-.796a1.074 1.074 0 00-.77-.329h-9.82c-.288 0-.566.118-.77.33-.205.21-.32.497-.32.795V21","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M27.131 20.105a.58.58 0 01.57-.054.51.51 0 01.22.183c.053.08.08.172.079.266v6.495a.975.975 0 01-.313.71c-.2.19-.472.295-.755.295H13.068c-.283 0-.555-.106-.755-.294a.975.975 0 01-.313-.71V20.5a.467.467 0 01.08-.266.51.51 0 01.22-.183.58.58 0 01.569.054l5.824 3.95c.376.278.84.428 1.318.428.477 0 .941-.15 1.317-.427l5.803-3.951z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17 15h6M17 18h3","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    